<template>
	<div>
		<modal
			:exibir="exibir"
			:titulo="'Escolha o tipo de assinatura'"
			:max-width="330"
			:is-confirmar-visivel="false"
			:custom-actions="true"
			@close="fecharModal"
		>
			<template #body>
				<div class="arp-botoes-assinatura">
					<botao-adicionar
						label="ELETRÔNICA"
						v-az-auth="permissaoAssinaturaEletronica"
						@adicionar="abrirOuFecharModalAssinaturaEletronica"
					></botao-adicionar>

					<botao-adicionar
						label="DIGITAL"
						v-az-auth="permissaoAssinaturaDigital"
						@adicionar="abrirOuFecharModalAssinaturaDigital"
					></botao-adicionar>
				</div>
			</template>
			<template #actions></template>
		</modal>

		<modal-assinatura-eletronica
			v-if="exibirModalAssinaturaEletronica"
			titulo="Assinar Eletronicamente"
			nome-botao-confirmar="Assinar"
			:exibir="exibirModalAssinaturaEletronica"
			@fechar-modal="abrirOuFecharModalAssinaturaEletronica"
			@fechar-modal-pai="fecharModal"
			@assinar-eletronicamente="$emit('assinar-eletronicamente')"
		></modal-assinatura-eletronica>

		<modal-assinatura-digital
			v-if="exibirModalAssinaturaDigital"
			titulo="Extensão Lacuna WebPki"
			subtitulo="A extensão WebPki é necessária para continuar o processo da assinatura digital."
			mensagem="Deseja instalar agora?"
			:exibir="exibirModalAssinaturaDigital"
			nome-botao-confirmar="Assinar"
			@assinar-digitalmente="assinarDigitalmente"
			@fechar-modal="abrirOuFecharModalAssinaturaDigital"
			@fechar-modal-pai="fecharModal"
		></modal-assinatura-digital>
	</div>
</template>
<script>
import ModalAssinaturaEletronica from '@/views/components/assinatura/eletronica/ModalAssinaturaEletronica.vue'
import { mutationTypes } from '@/core/constants'
import ModalAssinaturaDigital from '@/views/components/assinatura/digital/ModalAssinaturaDigital.vue'
import BotaoAdicionar from '@/views/components/botoes/adicionar/BotaoAdicionar.vue'

export default {
	name: 'modal-selecao-tipo-assinatura',
	components: { ModalAssinaturaDigital, BotaoAdicionar, ModalAssinaturaEletronica },
	props: {
		permissaoAssinaturaDigital: {
			type: String,
			required: true,
		},
		permissaoAssinaturaEletronica: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			exibirModalAssinaturaEletronica: false,
			exibirModalAssinaturaDigital: false,
		}
	},
	computed: {
		exibir() {
			return this.$store.state.modalAssinaturaFlowbee.exibir
		},
	},
	beforeDestroy() {
		this.limparFormulario()
	},
	methods: {
		abrirOuFecharModalAssinaturaEletronica() {
			this.exibirModalAssinaturaEletronica = !this.exibirModalAssinaturaEletronica
		},
		abrirOuFecharModalAssinaturaDigital() {
			this.exibirModalAssinaturaDigital = !this.exibirModalAssinaturaDigital
		},
		fecharModal() {
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.SET_EXIBICAO, false)
			this.limparFormulario()
		},
		limparFormulario() {
			this.$store.commit(mutationTypes.COMUM.MODAL_ASSINATURA_FLOWBEE.LIMPAR)
		},
		async assinarDigitalmente(certificadoThumbprint) {
			await this.$emit('assinar-digitalmente', certificadoThumbprint)
		},
	},
}
</script>
<style lang="stylus" scoped>
.arp-botoes-assinatura
	display flex
	align-items center
	margin-top 20px
	width 100%
	justify-content space-between

>>>.v-btn
	min-width 7.8125rem !important
</style>
